import * as _ from "lodash";

var setupDeviceSize = function ($rootScope, $timeout) {
  $rootScope.breakpoints = {
    sm: 375,
    md: 700,
    lg: 1024,
    xl: 1440,
  };
  function deviceResize() {
    $rootScope.windowWidth = window.innerWidth;
    window.mobileMode = $rootScope.windowWidth < $rootScope.breakpoints.md;
    $rootScope.safeApply();
  }
  var _deviceResize = _.debounce(deviceResize, 1000 / 60);
  window.addEventListener("resize", _deviceResize);

  if ($rootScope.C.APP_NAME == "referrals") {
    $timeout(deviceResize);
  } else {
    deviceResize();
  }
};

export default setupDeviceSize;
